import { render, staticRenderFns } from "./pbi-dnc-unmetdemand-sales-gap-latam.page.vue?vue&type=template&id=1fd062b2"
import script from "./pbi-dnc-unmetdemand-sales-gap-latam.page.vue?vue&type=script&lang=ts"
export * from "./pbi-dnc-unmetdemand-sales-gap-latam.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports